/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-03-15 16:34:20
 */

import React, { useMemo, useState } from 'react'
import { VerifyResult, VerifyAuthResult } from '../types'
import CardFrame from './components/CardFrame'
import VerifyResultPhoto from './verifyResultPhoto'
import { useAppDispatch } from '../../../app/hooks'
import { setLoading } from '../../../actions/main'
import { queryVerifyDetail } from '../../../actions/verify'
import DetailDrawer from './components/DetailDrawer'
import useVerifyAuthMethods from '../useVerifyAuthMethods'
import sensors from '../../../utils/sensors'

interface ResultCardProps {
  result: VerifyResult
  reportSaClickEvent: (event: string) => void
}

export default ({ result, reportSaClickEvent }: ResultCardProps) => {
  const { list, status, taskID } = result
  const dispatch = useAppDispatch()
  const [choosePhoto, setChoosePhoto] = useState('')
  const [photoDetail, setPhotoDetail] = useState<VerifyAuthResult | null>(null)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const { isFakeCheck, isTruthCheck } = useVerifyAuthMethods()

  const queryPhotoDetail = async (photoUrl) => {
    if (status === 'success') {
      reportSaClickEvent('clickTruePhoto')
    } else if (status === 'fail') {
      reportSaClickEvent('clickFalsePhoto')
    } else {
      reportSaClickEvent('clickUncertainPhoto')
    }
    setChoosePhoto(photoUrl)
    dispatch(setLoading(true))
    try {
      let res = await dispatch(
        queryVerifyDetail({
          taskID: taskID,
          photoUrl: photoUrl
        })
      )
      setPhotoDetail(res)
      setDrawerVisible(true)
      dispatch(setLoading(false))
      if (isFakeCheck(res.status) || isTruthCheck(res.status)) {
        const showSelfLocationTag =
          isTruthCheck(res.status) && res?.PhotoExt?.isSelfLocation === 'true'
        sensors.track('web_show_pop_photo_verification_result', {
          result: status === 'success' ? 'PASS' : 'FALSE',
          photoResolution: res.PhotoWideLength,
          antiFakeCode: res.PhotoExt.antiFakeCode,
          antiFakeTime: res.PhotoExt.serverTime,
          antiFakeLongitude: res.PhotoLng,
          antiFakeLatitude: res.PhotoLat,
          ossUrl: 'http://net-cloud.xhey.top/authVerify/photos',
          errorCode: res.status,
          photoFilename: res.PhotoExt.photoFilename,
          serverTime: res.PhotoExt.serverTime,
          antifakecodes: res.PhotoExt.ocr_antifakecode,
          ocr_times: res.PhotoExt.ocr_times,
          ocr_locations: res.PhotoExt.ocr_locations,
          ocr_content: res.PhotoExt.ocr_content,
          bool1: showSelfLocationTag // 是否展示「自定义地点」标识
        })
      }
    } catch (error) {
      dispatch(setLoading(false))
    }
  }

  return (
    <CardFrame result={result}>
      <div className="result-card-content">
        {list.map((ele, index) => {
          return (
            <div
              className="photo-item"
              key={index}
              onClick={() => queryPhotoDetail(ele.photoUrl)}
            >
              <VerifyResultPhoto photo={ele} status={status} />
            </div>
          )
        })}
      </div>
      <DetailDrawer
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        choosePhoto={choosePhoto}
        photoDetail={photoDetail as VerifyAuthResult}
        reportSaClickEvent={reportSaClickEvent}
      />
    </CardFrame>
  )
}
